// extracted by mini-css-extract-plugin
export default {"leftDash":"InputField_leftDash__kPVX-"};